export const WINEFO_URL = 'https://www.winefo.eu';
export const WINEFO_BLOG = 'https://www.Winefo.eu/blog';
export const TERMS_AND_CONDITIONS =
  'https://9b3ac1fd-8578-4843-bb63-d1a017b304f5.usrfiles.com/ugd/9b3ac1_e9c37dbcbe3b4068829b438fda6be127.pdf';
export const PRIVACY_POLICY =
  'https://9b3ac1fd-8578-4843-bb63-d1a017b304f5.usrfiles.com/ugd/9b3ac1_5a3137af5c7b4c48923efda57447b13c.pdf';
